import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-text-warning',
  templateUrl: './text-warning.component.html',
  styleUrls: ['./text-warning.component.scss']
})
export class TextWarningComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}